import { type FC, memo } from "react";
import type { EventListGridItem } from "src/http/types";
import { useAppContext } from "src/shared/context/AppContext";
import { useTeamThemes } from "src/website-apps/shared/hooks/useTeamThemes";
import { SingleEventBodyMobile } from "./SingleEventBodyMobile";

interface Props {
  event: EventListGridItem;
  primaryColor?: string | undefined;
  openNotificationHandler: (eventId: number) => void;
}

export const EventCardMobile: FC<Props> = memo(({ event, primaryColor, openNotificationHandler }) => {
  const teamThemes = useTeamThemes(event.eventMetadata);
  const appContext = useAppContext();
  const isHomeGame = event.eventMetadata?.sports?.homeTeamId === appContext.categoryId;

  return (
    <SingleEventBodyMobile
      event={event}
      isHomeGame={isHomeGame}
      teamThemes={teamThemes}
      primaryColor={primaryColor}
      openNotificationHandler={openNotificationHandler}
    />
  );
});

EventCardMobile.displayName = "EventCardMobile";
